import { LandingPageModel } from '../../models/landingPageModel'
import React from 'react'

export type ViddyLPContext = {
    landingPage: LandingPageModel
    viddyId: string
    discountCode: string | null
}

export const ViddyLPContext = React.createContext<ViddyLPContext>({
    landingPage: {} as LandingPageModel,
    viddyId: '',
    discountCode: null,
})
